<script lang="ts">
    import { get } from 'svelte/store';
    import { page } from '$app/state';
    import { isActiveRoute } from '$src/lib/services/navigation';
    import PageBuilder from '../PageBuilder/PageBuilder.svelte';
    import type { TRouteId } from '$src/generated/routeIds';
    import { afterNavigate } from '$app/navigation';
    import { onMount } from 'svelte';

    type TStaticBlocks = Awaited<typeof staticBlocks>;

    let staticBlocks = $derived(page.data.staticBlocks);
    let debug = $derived(page.data.debugMode);
    let blocks: null | Omit<TStaticBlocks, 'excludedPageGroups'> = $state(null);
    let excludedGroups: TRouteId[] = $state([]);
    let shouldNotRenderStaticBlocks = $state(true);

    // The 3 horse men of reactivity ...
    onMount(() => {
        staticBlocks.then(({ excludedPageGroups, ...staticBlocks }) => {
            // update when promise resolved
            excludedGroups = excludedPageGroups;
            blocks = staticBlocks;
        });
    });
    $effect(() => {
        //recompute is excludedGroups changes
        shouldNotRenderStaticBlocks = excludedGroups.some((g) => get(isActiveRoute(g)));
    });
    afterNavigate(() => {
        //recompute after each navigation
        shouldNotRenderStaticBlocks = excludedGroups.some((g) => get(isActiveRoute(g)));
    });
</script>

{#if !shouldNotRenderStaticBlocks && blocks}
    <PageBuilder {...blocks.commonBlocks} {debug} />
    {#if page.data.isLoggedIn}
        <PageBuilder {...blocks.lisOnlyBlocks} {debug} />
    {:else}
        <PageBuilder {...blocks.losOnlyBlocks} {debug} />
    {/if}
{/if}
